import { Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/step_1_sauce.png",
  alt: "Step 1: Choose Your Sauce - Black Pepper or Mushroom (第一步：选择酱汁 - 黑胡椒或蘑菇)"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/step_2_protein.png",
  alt: "Step 2: Choose Your Protein - Sliced Pork, Popcorn Chicken, or Seafood (第二步：选择肉类)"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/step_3_sizzle.png",
  alt: "Step 3: Hear the Sizzle - Action shot of the steaming hotplate noodles (第三步：铁板面滋滋声)"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/great_taipei_sign.png",
  alt: "Great Taipei (大台北) - The Ultimate Taiwanese Food Court Experience in Singapore"
}];
export default function FacebookHighlights() {
  return <section data-section-id="99633" id="the-sizzle-experience" className="relative w-full bg-background dark text-foreground">
      {}
      <div className="absolute top-4 right-4 z-10 md:top-6 md:right-6">
        <Badge asChild variant="default" className="shadow-2xl hover:scale-110 transition-transform duration-300 cursor-pointer py-3 px-6 text-sm bg-primary text-primary-foreground border-none rounded-full">
          <Link to="/GreatTaipeiPage" newTab>
            <Facebook className="w-4 h-4 mr-2" />
            <span className="hidden sm:inline font-bold tracking-tighter uppercase">Follow Great Taipei 大台北</span>
            <span className="sm:hidden font-bold tracking-tighter uppercase">Follow Us</span>
          </Link>
        </Badge>
      </div>

      {}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 w-full">
        {galleryImages.map((image, i) => <div key={i} data-index={i} className="relative overflow-hidden group aspect-square sm:aspect-[4/3] lg:aspect-[3/4] bg-muted">
            <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110" loading="lazy" />
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-primary/70 via-secondary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
          </div>)}
      </div>
    </section>;
}